import axios from "axios";
import { getAPIBaseUrlVersion1 } from "../utils/constants";

export const getAssets = async () => {
  const apiUrl = getAPIBaseUrlVersion1();
  return await axios.get(`${apiUrl}/get_logo`);
};
